import { getLowestItemPrice } from './item-price-utils';
export const getLowestItemPricesForParentSalesOptions = (options) => {
    return options.reduce((prices, option) => {
        const lowestPrice = getLowestItemPrice(option.prices);
        if (lowestPrice)
            prices.push(lowestPrice); // There should always be a lowest price as with the correct config, all items would at least have a default price
        return prices;
    }, []);
};
